import React from 'react';
import type { ImageProps } from 'next/legacy/image';
import classNames from 'classnames';
import { PreloadImage } from '$util/PreloadImage';
import type { Props } from '$components/basic/Image';
import type { MediaQueryBreakpoint } from '$util/theme/withResponsive';
import { Image } from '$components/basic/Image';
import styles from './index.module.scss';

export interface ResponsiveImageProps extends Props {
  readonly src: string;
  readonly alt: string;
  readonly fromBreakpoint?: MediaQueryBreakpoint;
  readonly toBreakpoint?: MediaQueryBreakpoint;
  readonly width?: number;
  readonly height?: number;
  readonly preload?: boolean;
  readonly lazy?: boolean;
  readonly layout?: ImageProps['layout'];
}

export function ResponsiveImage({
  className,
  src,
  fromBreakpoint,
  toBreakpoint,
  alt,
  width,
  height,
  preload = false,
  objectFit = 'cover',
  objectPosition = 'center',
  lazy = true,
  layout = 'fill',
  ...props
}: ResponsiveImageProps): JSX.Element {
  return (
    <>
      {preload && (
        <PreloadImage provider="cloudinary" src={src} displayFrom={fromBreakpoint} displayTo={toBreakpoint} />
      )}
      <Image
        className={classNames(ResponsiveImage.displayName, className, styles.responsiveImage)}
        provider="cloudinary"
        src={src}
        layout={layout}
        objectFit={objectFit}
        objectPosition={objectPosition}
        alt={alt}
        width={width}
        height={height}
        displayFrom={fromBreakpoint}
        displayTo={toBreakpoint}
        loading={preload || !lazy ? 'eager' : 'lazy'}
        {...props}
      />
    </>
  );
}
ResponsiveImage.displayName = 'ResponsiveImage';
